// RichIframe.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { dispatchGlobalClickIfNeeded } from '../resource/createTrackingEvent.js';
import { NULL_FUNCTION } from '../resource/defaults.js';

export const RichIframe = ({
  onLoad = NULL_FUNCTION,
  onClickContentWindow = NULL_FUNCTION,
  ...restIframeAttributes
}) => {
  const trackingPayload = restIframeAttributes?.['data-tracking_payload'];
  const handleClick = clickEvent => {
    dispatchGlobalClickIfNeeded(clickEvent, 'IFRAME', trackingPayload);
    onClickContentWindow(clickEvent);
  };
  return (
    <StyledRichIframe
      onLoad={e => {
        if (e.target?.contentWindow) {
          try {
            e.target?.contentWindow.addEventListener('click', handleClick);
          } catch (_) {
            // skip cross-origin frame issue
          }
        }
        onLoad(e);
      }}
      title="rich text content"
      {...restIframeAttributes}
    />
  );
};

RichIframe.propTypes = {
  onLoad: PropTypes.func,
  onClickContentWindow: PropTypes.func,
};

// eslint-disable-next-line swag/no-native-iframe
const StyledRichIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;

export default RichIframe;
